<template>
    <v-expansion-panel-content
        class="workflow__item__panel"
        :class="{ 'workflow__item__panel--not-valid': !valid }"
    >
        <template v-slot:header>
            <div
                class="workflow-item__header"
            >
                <span class="workflow-item__header__icon">
                    <icon
                        class="icon-primary"
                        :icon="iconPicker"
                        :height="20"
                        :width="20"
                    ></icon>
                </span>
                <h3 class="workflow-item__header__text">
                    {{ decodeAlarmPipeline }}
                </h3>
            </div>
        </template>
        <v-card>
            <v-form
                ref="form"
                v-model="valid"
                class="form alarm-form"
            >
            <div class="input-wrapper alarm-form__core">
                <label for="" class="alarm-form__label"> Alarm Type </label>
                <v-select
                    v-model="alarmProcessed.type"
                    :items="filteredAlarmPipelines"
                    class="small-field"
                    label="Select alarm type"
                    item-text="key"
                    item-value="id"
                    outline
                    single-line
                ></v-select>
            </div>
            <component
                :is="decodeAlarmPipeline"
                :alarm-processed="alarmProcessed"
                @addRecipient="onAddRecipient"
                @deleteRecipient="onDeleteRecipient"
            ></component>
            <div class="buttons-wrapper">
                <sp-btn text="Delete Item" @click.native="onDeleteItem" icon="delete"></sp-btn>
                <p v-if="!valid" class="workflow-item__header__warning">
                    Please fill all fields or delete item.
                </p>
            </div>
            </v-form>
        </v-card>
    </v-expansion-panel-content>
</template>

<script>

import { searchEnumById } from '@/helpers/Utils'
import { mapGetters } from 'vuex'
import RaiseEvent from '@/views/_components/alarmsPipelines/alarmTypes/RaiseEvent'
import SendEmail from '@/views/_components/alarmsPipelines/alarmTypes/SendEmail'
import Icon from '@/components/atoms/Icon'
import SpBtn from '@/components/forms/SpBtn'

export default {
    name: 'DeviceAlarmsWorkflowItem',
    components: {
        Icon,
        SpBtn,
        RaiseEvent,
        SendEmail
    },
    props: {
        alarmProcessed: {
            type: [Object, null],
            required: true
        },
        index: {
            type: [Number],
            required: true
        },
        availableAlarmTypeIds: {
            type: Array,
            required: true
        }
    },
    mounted () {
    },
    updated () {
        this.valid = this.$refs.form.value
    },
    beforeDestroy () {
        this.$emit('disableWorkflow', false)
    },
    computed: {
        ...mapGetters({
            getAlarmPipelines: 'dictionaryModule/getAlarmPipelines'
        }),
        decodeAlarmPipeline () {
            return searchEnumById(this.getAlarmPipelines, this.alarmProcessed.type)
        },
        filteredAlarmPipelines () {
            return this.getAlarmPipelines.filter(alarm => {
                return [this.alarmProcessed.type, ...this.availableAlarmTypeIds].includes(alarm.id)
            })
        },
        iconPicker () {
            let iconName = ''
            switch (this.alarmProcessed.type) {
                case 1:
                    iconName = 'bell-regular'
                    break
                case 3:
                    iconName = 'envelope-regular'
                    break
            }
            return iconName
        }
    },
    data () {
        return {
            valid: false
        }
    },
    watch: {
        'alarmProcessed.type': {
            handler (alarmType) {
                const index = this.index
                this.$emit('typeChange', { alarmType, index })
            }
        },
        valid (newVal, oldVal) {
            if (false === newVal) {
                this.$emit('disableWorkflow', true)
            } else if (false === oldVal && true === newVal) {
                this.$emit('disableWorkflow', false)
            }
        }
    },
    methods: {
        onDeleteItem () {
            this.$emit('deleteItem', this.index)
        },
        onAddRecipient (recipientEmail) {
            this.$emit('addRecipient', this.index, recipientEmail)
        },
        onDeleteRecipient (recipientEmail) {
            this.$emit('deleteRecipient', this.index, recipientEmail)
        }
    }
}
</script>

<style lang="scss" scoped>
.workflow__item__panel--not-valid {
    box-shadow: 0px 0px 15px 3px rgba(255, 0, 0, 0.29);
}

.workflow-item {
    &__header {
        display: flex;
        border: 1px solid black;
        color: $font;
        &__icon {
            background: $primary;
            display: inline-block;
            padding: 5px;
        }
        &__text {
            width: 100%;
            display: flex;
            padding: 5px 5px 5px 15px;
            font-weight: 500;
            font-size: 1rem;
            background: $secondary;
            justify-content: flex-start;
            align-items: center;
        }
        &__warning {
            width: fit-content;
            display: flex;
            padding: 5px 10px;
            margin: 0;
            font-weight: 500;
            font-size: 1rem;
            border-radius: 4px;
            border: 1px solid red !important;
            background: #ffdce0 !important;
            justify-content: center;
            align-items: center;
        }
    }
}

::v-deep.workflow__item__panel {
    .alarm-form {
        padding: 20px;
        &__label {
            display: block;
            font-weight: bold;
            font-size: 1rem;
            margin: 0 0 10px 0;
        }
        &__email-chips {
            margin-bottom: 20px;
        }
        &__icon {
            cursor: pointer;
            background: rgb(156, 156, 156);
            border-radius: 50%;
            padding: 2px;
            margin-left: 3px;
        }
    }
    .row-wrapper {
        display: flex;
        justify-content: space-between;
        .input-wrapper {
            width: 48%
        }
    }
    .buttons-wrapper {
        display: flex;
        justify-content: space-between;
    }

    .text-field-wrapper {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        .v-input__slot {
            border-top-right-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
        }
        .input_with-button {
            display: inline-block;
        }
        .inner-btn {
            display: inline-block;
            padding-bottom: 2px;
            border: 1px solid black;
        }
    }
    .hidden-input {
        visibility: hidden;
        width: 0px;
        height: 0px;
    }
}

.icon-primary {
    color: $icon-primary;
}
</style>
